export default __webpack_public_path__ + "0a99722e34c3647d2b45e8d15066496b.png";